import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const InteractiveString = () => {
  const pathRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const setPath = () => {
      const width = window.innerWidth;

      if (pathRef.current) {
        pathRef.current.setAttribute(
          'd',
          `M 0 50 Q ${width / 2} 50 ${width} 50`
        );
      }
    };

    setPath();
    window.addEventListener('resize', setPath);

    return () => {
      window.removeEventListener('resize', setPath);
    };
  }, []);

  const handleMouseMove = (event) => {
    if (!pathRef.current || !containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    const y = event.clientY - rect.top;
    const width = window.innerWidth;

    gsap.to(pathRef.current, {
      attr: {
        d: `M 0 50 Q ${event.clientX} ${y} ${width} 50`
      },
      duration: 0.1,
      ease: 'power2.out'
    });
  };

  const handleMouseLeave = () => {
    if (!pathRef.current) return;

    const width = window.innerWidth;

    gsap.to(pathRef.current, {
      attr: {
        d: `M 0 50 Q ${width / 2} 50 ${width} 50`
      },
      duration: 1.5,
      ease: 'elastic.out(1,0.2)'
    });
  };

  return (
    <div
      ref={containerRef}
      className="w-full h-24 relative z-50 cursor-crosshair"
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <svg
        className="w-full h-full absolute top-0 left-0 pointer-events-none overflow-visible"
        aria-hidden="true"
      >
        <path
          ref={pathRef}
          d=""
          stroke="rgba(255,255,255,0.2)"
          strokeWidth="1"
          fill="transparent"
        />
      </svg>
    </div>
  );
};

export default InteractiveString;